import { useAxios } from '@Shared/composables/useAxios';
import { usePortalUri } from '@Shared/composables/usePortalUri';
import { ContentItemInfo, ContentProfile } from '@Shared/types/portal/ContentItem';

export async function getContentProfiles(): Promise<ContentProfile[]> {
  const uri = usePortalUri();
  const axios = useAxios();
  const response = await axios.get<ContentProfile[]>(`${uri}/api/content`);
  return response.data;
}

export async function getContentItems(profileName: string): Promise<ContentItemInfo[]> {
  const uri = usePortalUri();
  const axios = useAxios();
  const response = await axios.get<ContentItemInfo[]>(`${uri}/api/content/profile/${profileName}`);
  return response.data;
}
